export var indexPrefix  = '@';
export var scalePrefix  = '%';
export var dataPrefix   = ':';



// WEBPACK FOOTER //
// ./~/vega-parser/src/parsers/expression/prefixes.js